<template>
  <div class="news-list-page">
    <s-r-m-header activeVal="news" />

    <section class="news-hero">
      <div class="hero-inner">
        <div class="hero-label">News</div>
        <h1>新闻资讯</h1>
        <p>关注璞华产品动态、行业洞察与研发数字化实践。</p>
      </div>
    </section>

    <main class="news-container">
      <div
        class="news-card pointer"
        v-for="item in newsList"
        :key="item.sourceId"
        @click="goDetail(item.sourceId)"
      >
        <div class="cover-box">
          <img :src="item.cover" :alt="item.title">
        </div>
        <div class="card-content">
          <div class="publish-date">{{ item.publishDate }}</div>
          <h2>{{ item.title }}</h2>
          <p>{{ item.summary }}</p>
          <span class="read-more">查看详情</span>
        </div>
      </div>
    </main>

    <footer-box />
  </div>
</template>

<script>
import SRMHeader from '@/components/SRMHeader/index'
import FooterBox from '@/components/FooterBox'
import newsList from '@/static/js/newsData'

export default {
  name: 'NewsList',
  components: {
    SRMHeader,
    FooterBox
  },
  metaInfo() {
    return {
      title: '新闻资讯'
    }
  },
  data() {
    return {
      newsList
    }
  },
  methods: {
    goDetail(sourceId) {
      this.$router.push({
        name: 'newsDetail',
        params: { sourceId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.news-list-page {
  min-height: 100vh;
  background: #f7f9fc;
}

.news-hero {
  padding: 15rem 0 8.4rem;
  background: linear-gradient(120deg, #edf6ff 0%, #ffffff 58%, #fff3f3 100%);
}

.hero-inner {
  width: 120rem;
  max-width: calc(100% - 3.2rem);
  margin: 0 auto;
  text-align: center;
}

.hero-label {
  color: #fb0000;
  font-size: 1.8rem;
  font-weight: 600;
  letter-spacing: .2rem;
  text-transform: uppercase;
}

.hero-inner h1 {
  margin: 1.8rem 0 1.6rem;
  color: #1f2d3d;
  font-size: 4.4rem;
  line-height: 1.3;
}

.hero-inner p {
  margin: 0;
  color: #607080;
  font-size: 1.8rem;
}

.news-container {
  width: 120rem;
  max-width: calc(100% - 3.2rem);
  margin: 0 auto;
  padding: 6.4rem 0 9rem;
}

.news-card {
  display: flex;
  overflow: hidden;
  margin-bottom: 2.8rem;
  background: #fff;
  border-radius: 1.6rem;
  box-shadow: 0 1.4rem 4rem rgba(31, 45, 61, .08);
  transition: transform .2s ease, box-shadow .2s ease;
}

.news-card:hover {
  transform: translateY(-.4rem);
  box-shadow: 0 1.8rem 4.8rem rgba(31, 45, 61, .12);
}

.cover-box {
  flex: 0 0 36rem;
  height: 23rem;
  background: #e9eef5;
}

.cover-box img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  flex: 1;
  padding: 3.6rem 4.2rem;
}

.publish-date {
  color: #8a96a3;
  font-size: 1.5rem;
}

.card-content h2 {
  margin: 1.4rem 0 1.6rem;
  color: #1f2d3d;
  font-size: 2.6rem;
  line-height: 1.4;
}

.card-content p {
  margin: 0;
  color: #607080;
  font-size: 1.7rem;
  line-height: 1.8;
}

.read-more {
  display: inline-block;
  margin-top: 2.8rem;
  color: #1385f5;
  font-size: 1.6rem;
  font-weight: 600;
}

@media screen and (max-width: 76.8rem) {
  .news-hero {
    padding: 11rem 0 5.6rem;
  }

  .hero-inner h1 {
    font-size: 3.2rem;
  }

  .hero-inner p {
    font-size: 1.6rem;
  }

  .news-container {
    padding: 4rem 0 5.6rem;
  }

  .news-card {
    display: block;
  }

  .cover-box {
    width: 100%;
    height: 21rem;
  }

  .card-content {
    padding: 2.6rem 2.2rem;
  }

  .card-content h2 {
    font-size: 2.2rem;
  }
}
</style>
